import React, { useEffect } from 'react';
import PropType from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ReactComponent as UnsuccessfulIcon } from '../../assets/images/svg/unsuccessful.svg';
import Paragraph from '../Paragraph/Paragraph';
import { StatusModalBody, StatusModalIconWrap } from '../Modals/StatusModal';
import { SUPPORT_MODAL_OPEN } from '../../constants/sessionStorage';
import AnchorOnClick from '../Anchor/AnchorOnClick';
import Button from '../Button/Button';
import { useSessionStorageState } from '../../util/hooks/useSessionStorageState';
import {
  deleteWizardKey,
  setWizardContent,
} from '../../util/helpers/wizardHelpers';
import SupportModal from '../Modals/SupportModal/SupportModal';

const PaymentFailureStatus = ({
  setModalTitleSuffix,
  callGtm,
  handleBack,
  paymentMethod,
  getPostPaidError,
  getPostPaidErrorMessage,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (setModalTitleSuffix) {
      setModalTitleSuffix('');
    }

    if (callGtm) {
      callGtm();
    }
  }, []); // eslint-disable-line

  const [isSupportModalOpen, setIsSupportModalOpen] = useSessionStorageState(
    SUPPORT_MODAL_OPEN,
    false,
  );

  const openSupportModal = () => {
    setIsSupportModalOpen(true);
    setWizardContent(SUPPORT_MODAL_OPEN, true);
  };

  const closeSupportModal = () => {
    setIsSupportModalOpen(false);
    deleteWizardKey(SUPPORT_MODAL_OPEN);
  };

  return (
    <>
      {isSupportModalOpen ? (
        <SupportModal
          avoidClearingStorage
          isOpen={isSupportModalOpen}
          close={closeSupportModal}
          goBack={closeSupportModal}
        />
      ) : (
        <StatusModalBody>
          <StatusModalIconWrap>
            <UnsuccessfulIcon />
          </StatusModalIconWrap>

          <Paragraph isColumn centerText bold marginBottom={24}>
            {t('buyWizard.postPaid.paymentFailureTitle')}
          </Paragraph>

          {getPostPaidError && getPostPaidErrorMessage && (
            <Paragraph fullWidth marginBottom={12}>
              {getPostPaidErrorMessage}
            </Paragraph>
          )}

          {getPostPaidError === 'PlaidLoginRequired' && (
            <>
              <Paragraph marginBottom={8}>
                {t('buyWizard.postPaid.plaidLoginErrorParagraph1')}
              </Paragraph>
              <Paragraph marginBottom={8} marginLeft={12}>
                <ul>
                  <li>{t('buyWizard.postPaid.plaidLoginErrorFixList1')}</li>
                  <li>{t('buyWizard.postPaid.plaidLoginErrorFixList2')}</li>
                </ul>
              </Paragraph>
              <Paragraph>
                {t('buyWizard.postPaid.plaidLoginErrorParagraph2')}
                <Paragraph marginBottom={24}>
                  {t('buyWizard.postPaid.plaidLoginErrorParagraph3')}
                  <AnchorOnClick
                    onClick={(event) => {
                      event.preventDefault();
                      openSupportModal();
                    }}
                  >
                    {t('buyWizard.postPaid.plaidLoginErrorParagraph4')}
                  </AnchorOnClick>
                </Paragraph>
              </Paragraph>
            </>
          )}

          {/* Requred by the PBI 59274 to be removed only for CC from UI */}
          {paymentMethod?.PaymentMethodType === 2 &&
            getPostPaidError !== 'PlaidLoginRequired' && (
              <Paragraph marginBottom={12}>
                {t('buyWizard.postPaid.paymentFailureParagraph1', {
                  paymentType: 'ACH bank connection.',
                })}
              </Paragraph>
            )}
          {/* <Paragraph marginBottom={12}>
            {t('buyWizard.postPaid.paymentFailureParagraph2')}
          </Paragraph> */}
          {getPostPaidError !== 'PlaidLoginRequired' && (
            <Paragraph marginBottom={24}>
              {t('buyWizard.postPaid.paymentFailureContactSupport1')}
              <AnchorOnClick
                onClick={(event) => {
                  event.preventDefault();
                  openSupportModal();
                }}
              >
                {t('buyWizard.postPaid.paymentFailureContactSupport2')}
              </AnchorOnClick>

              {t('buyWizard.postPaid.paymentFailureContactSupport3')}
            </Paragraph>
          )}

          <Button
            variant="primary"
            marginTop
            showOnlyPrimary
            textTransform="capitalize"
            onClick={handleBack}
          >
            {t('buyWizard.postPaid.chooseDifferentPaymentSupport')}
          </Button>
        </StatusModalBody>
      )}
    </>
  );
};

PaymentFailureStatus.propTypes = {
  setModalTitleSuffix: PropType.func,
  callGtm: PropType.func,
  handleBack: PropType.func,
  paymentMethod: PropType.shape({
    PaymentMethodType: PropType.number,
  }),
  getPostPaidError: PropType.string,
  getPostPaidErrorMessage: PropType.string,
};

export default PaymentFailureStatus;
